import { graphql, Link, useStaticQuery } from 'gatsby';
import styled, { css } from 'styled-components';
import { useState } from 'react';
import { usePageId } from '../../hooks/usePageId';
import { usePageLocale } from '../../hooks/usePageLocale';
import { ChevronDown } from '../vectors/ChevronDown';

const Dropdown = styled.div`
  position: relative;
  display: inline-block;
  padding: 0 10px;
`;

const DropdownButton = styled.button`
  text-transform: uppercase;
  background: #11284A 0% 0% no-repeat padding-box;
  border: 1px solid #B5A371;
  cursor: pointer;
  color: #B3A170;
  font: normal normal bold 16px Montserrat;
  padding: 3px 8px;
  justify-content: center;
  display: inline-flex;
  align-items: center;
  width: 60px;
  ${({ $isOpen }) => $isOpen ? css`border-radius: 5px 5px 0 0;` : css`border-radius: 5px`}
`;

const DropdownContent = styled.div`
  position: absolute;
  background: #11284A 0% 0% no-repeat padding-box;
  border: 1px solid #B5A371;
  border-top: 0 none;
  border-radius: 0 0 5px 5px;
  width: 60px;
  z-index: 1;
  ${({ $isOpen }) => $isOpen ? css`display: block` : css`display: none`}
`;

const DropdownLink = styled(Link)`
  text-transform: uppercase;
  cursor: pointer;
  color: #B3A170;
  font: normal normal bold 16px Montserrat;
  padding: 6px 10px;
  display: block;
`;

const Chevron = styled(ChevronDown)`
  transition-duration: 0.5s;
  transition-property: transform;
  ${({ $isOpen }) => $isOpen ? css`transform: rotate(180deg);` : css`transform: rotate(0deg);`}
`;

// Main component

export const LanguageSwitcher = () => {
  // STATE
  const [open, setOpen] = useState(false);

  // QUERY
  const data = useStaticQuery(graphql`
    query {
      datoCmsSite {
        locales
      }
      allSitePage {
        pageNodes: nodes {
          path
          pageContext
        }
      }
    }
  `);

  const {
    allSitePage: { pageNodes },
    datoCmsSite: { locales },
  } = data;

  const { pageId } = usePageId();
  const { locale: pageLocale } = usePageLocale();

  const getPathMatch = (switcherLocale) => {
    const pageContextMatch = pageNodes.find(
      ({ pageContext: { id, locale } }) =>
        id === pageId && locale === switcherLocale
    );

    return pageContextMatch?.path;
  };

  // HANDLERS
  const handleToggleOpen = () => {
    setOpen(!open);
  };
  const handleLinkClick = (locale) => {
    return () => {
      localStorage.setItem('lang', locale);
      setOpen(false);
    };
  };
  return (
    <Dropdown>
      <DropdownButton onClick={handleToggleOpen} $isOpen={open}>
        {pageLocale.split('-')[0]}
        &nbsp;
        <Chevron $isOpen={open} />
      </DropdownButton>
      <DropdownContent $isOpen={open}>
        {/* Add filter for display only it and en locales (request on 2/11/2023) */}
        {locales.filter((locale) => ['it-IT', 'en-US'].includes(locale)).filter((locale) => locale !== pageLocale).map((locale) => (
          <DropdownLink
            key={locale}
            to={getPathMatch(locale)}
            onClick={handleLinkClick(locale)}
          >
            {locale.split('-')[0]}
          </DropdownLink>
        ))}
      </DropdownContent>
    </Dropdown>
  );
};
